import videojs from 'video.js';
import window from 'global/window';
import document from 'global/document';

const Tech = videojs.getComponent('Tech');
const mergeOptions = videojs.mergeOptions;

/**
 * Базовый клас для подключения плеера на основе плагина.
 */
class PluginTech extends Tech {
  constructor(options, ready) {
    options = mergeOptions({
      attributes: {
        id: options.techId,
        name: options.techId,
        'class': 'vjs-tech'
      }
    }, options);

    super(options, ready);

    this.ready(() => this.attachPluginEvents(), true);

    if (options.source) {
      this.ready(() => {
        this.setSrc(options.source.src);
        if (options.autoplay) {
          this.play();
        }
      });
    }

    // Добавим дополнительный класс к основному элементу плеера
    setTimeout(() => {
      this.el_.parentNode.className += ' vjs-plugin-tech';
    }, 0);
  }

  dispose() {
    if (this.el_) {
      this.el_.parentNode.removeChild(this.el_);
    }
    super.dispose();
  }

  preload() {}

  load() {}

  reset() {}

  poster() {
    // Отключим компонент PosterImage
    return null;
  }

  setPoster() {}

  featuresNativeTextTracks() {
    // Отключим компонент TextTrackDisplay
    return true;
  }

  attachPluginEvents() {
    throw 'Not implemented';
  }

  isPluginReady() {
    throw 'Not implemented';
  }

  awaitPluginReady() {
    // Stop waiting if the tech has been disposed
    if (!this.el_) {
      return;
    }

    // Check if plugin is ready
    if (this.isPluginReady()) {
      console.log('plugin-tech: Plugin is ready');
      this.triggerReady();
    } else {
      window.setTimeout(() => this.awaitPluginReady(), 100);
    }
  }

  createEl() {
    this.el_ = super.createEl('embed', {}, this.options_.attributes);
    this.el_.tech = this;

    window.setTimeout(() => this.awaitPluginReady(), 0);

    return this.el_;
  }

  static canPlaySource(srcObj) {
    // By default accept to play any source
    return 'maybe';
  }

  static isPluginAvailable(type) {
    if (navigator.plugins) {
      let mime;
      let plugin;
      // Iterate over all installed plugins and their mime types
      for (let p = 0; p < navigator.plugins.length; p++) {
        plugin = navigator.plugins[p];
        for (let m = 0; m < plugin.length; m++) {
          mime = plugin[m];
          if (mime.type === type) {
            return true;
          }
        }
      }
    }
    return false;
  }

  static getAbsoluteUrl(url) {
    if (!PluginTech._a) {
      PluginTech._a = document.createElement('a');
    }
    PluginTech._a.href = url;
    return PluginTech._a.href;
  }
}

export default PluginTech;



// WEBPACK FOOTER //
// ./src/players/plugin-tech.js